import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: [], // array of { _id, name, filters: [] }
    isLoading: false,
    error: null
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        setFilters: (state, action) => {
            state.filters = action.payload;
        },
        addFilterGroup: (state, action) => {
            state.filters.push({ ...action.payload, filters: [] });
        },
        updateFilterGroup: (state, action) => {
            const index = state.filters.findIndex(f => f._id === action.payload._id);
            if (index !== -1) state.filters[index].name = action.payload.name;
        },
        removeFilterGroup: (state, action) => {
            state.filters = state.filters.filter(f => f._id !== action.payload);
        },
        addFilter: (state, action) => {
            // action.payload = { filterGroupId, filter }
            const group = state.filters.find(f => f._id === action.payload.filterGroupId);
            if (group) group.filters.push(action.payload.filter);
        },
        updateFilter: (state, action) => {
            // action.payload = { filterGroupId, filter }
            const group = state.filters.find(f => f._id === action.payload.filterGroupId);
            if (group) {
                const index = group.filters.findIndex(fl => fl._id === action.payload.filter._id);
                if (index !== -1) group.filters[index] = action.payload.filter;
            }
        },
        removeFilter: (state, action) => {
            // action.payload = { filterGroupId, filterId }
            const group = state.filters.find(f => f._id === action.payload.filterGroupId);
            if (group) group.filters = group.filters.filter(fl => fl._id !== action.payload.filterId);
        },
        setIsLoading: (state, action) => { state.isLoading = action.payload; },
        setError: (state, action) => { state.error = action.payload; }
    }
});

export const {
    setFilters,
    addFilterGroup,
    updateFilterGroup,
    removeFilterGroup,
    addFilter,
    updateFilter,
    removeFilter,
    setIsLoading,
    setError
} = filterSlice.actions;

export const FilterReducer = filterSlice.reducer;
